export default "__VITE_ASSET__bbb91d7f__"